// Full Royal Solutions price list. All prices are INKL. moms (25%).
// value = numeric incl-moms amount; unit drives label + estimate behaviour.
// kinds: hourly (unit 'time'), per-unit (unit 'kuvert'/'gæst'), surcharge (unit 'genstand'),
// one-off (unit 'stk'), isFrom => "fra"-price, quote => individuelt tilbud.

export const PRICING_GROUPS = [
  {
    id: "catering",
    title: "Events · Bryllupper · Fester — Catering",
    note: "Pakkerne er eksempler og kan tilpasses. “Fx” og “mulighed for” angiver valgfrie elementer – præcis menu sammensættes altid individuelt.",
    items: [
      {
        id: "royal-classic",
        name: "Royal Classic",
        value: 895,
        unit: "kuvert",
        bullets: [
          "Klassisk løsning – fx buffet eller serveret menu",
          "Typisk forret, hovedret og dessert",
          "Øl, sodavand og vand under middagen inkluderet",
          "Vin ikke inkluderet",
        ],
      },
      {
        id: "royal-premium",
        name: "Royal Premium",
        value: 1295,
        unit: "kuvert",
        bullets: [
          "Højere gastronomisk niveau",
          "3-retters menu eller udvidet premium buffet",
          "Øl, sodavand, vand + udvalgt hvid/rød/rosévin under middagen",
        ],
      },
      {
        id: "royal-signature",
        name: "Royal Signature",
        value: 1895,
        unit: "kuvert",
        bullets: [
          "Eksklusiv oplevelse med flere serveringer",
          "Fx snacks + 3-4 serveringer eller eksklusiv buffet",
          "Øl, sodavand, vand + vin",
        ],
      },
      {
        id: "royal-exclusive",
        name: "Royal Exclusive",
        value: 2795,
        unit: "kuvert",
        bullets: [
          "Komplet gastronomisk løsning",
          "Snacks/amuse + 4-5 serveringer",
          "Mulighed for premium kød, fisk, seafood, trøffel m.m.",
          "Premium vin inkluderet",
        ],
      },
      {
        id: "royal-imperial",
        name: "Royal Imperial",
        value: 5495,
        unit: "kuvert",
        bullets: [
          "Individuelt sammensat luksusmenu – 5-7 serveringer",
          "Mulighed for kaviar, seafood, eksklusive udskæringer, trøffel og desserter",
          "Topvin individuelt matchet",
        ],
      },
    ],
  },
  {
    id: "bar",
    title: "Bar — 4 timer",
    note: "Bartender: 429 kr./time pr. bartender (min. 4 timer). Ekstra drinkspakker: Cava/Prosecco +95 kr., Champagne fra +195 kr., Dessertvin/Port +75 kr. – pr. gæst.",
    items: [
      { id: "bar-classic", name: "Royal Bar Classic", value: 295, unit: "gæst", sub: "Ekstra time: +75 kr. pr. gæst" },
      { id: "bar-cocktail", name: "Royal Cocktail", value: 449, unit: "gæst", sub: "Ekstra time: +95 kr. pr. gæst" },
      { id: "bar-premium", name: "Royal Premium Bar", value: 695, unit: "gæst", sub: "Ekstra time: +135 kr. pr. gæst" },
    ],
  },
  {
    id: "personale",
    title: "Personale til fest & event",
    note: "Minimum 4 timer pr. medarbejder. Tillæg: søndag +35%, 9. arbejdstime og frem +50%, officiel helligdag/24.12/31.12 +100%. Akut booking: under 48 t +20%, under 24 t +30%. Højeste relevante tidstillæg gælder (lægges ikke sammen); akuttillæg kan lægges separat.",
    items: [
      { id: "opvasker", name: "Opvasker", value: 379, unit: "time" },
      { id: "eventpersonale", name: "Eventpersonale", value: 379, unit: "time" },
      { id: "kokkenmedhjaelper", name: "Køkkenmedhjælper", value: 429, unit: "time" },
      { id: "tjener", name: "Tjener", value: 399, unit: "time" },
      { id: "bartender", name: "Bartender", value: 429, unit: "time" },
      { id: "overtjener", name: "Overtjener / Afvikler", value: 499, unit: "time" },
    ],
  },
  {
    id: "rengoring",
    title: "Rengøring — private",
    note: "Minimum 2 timer. Erhvervsrengøring: individuelt tilbud.",
    items: [
      { id: "reng-kunde", name: "Kunden stiller produkter og udstyr", value: 329, unit: "time" },
      { id: "reng-produkter", name: "Vi medbringer produkter, kunden stiller udstyr", value: 369, unit: "time" },
      { id: "reng-alt", name: "Vi medbringer produkter + udstyr", value: 399, unit: "time" },
      { id: "reng-erhverv", name: "Erhvervsrengøring", quote: true },
    ],
  },
  {
    id: "havearbejde",
    title: "Havearbejde — private",
    note: "Minimum 2 timer pr. besøg.",
    items: [
      { id: "have-kunde", name: "Kunden stiller værktøj", value: 379, unit: "time", isFrom: true },
      { id: "have-alm", name: "Vi medbringer almindeligt værktøj", value: 419, unit: "time", isFrom: true },
      { id: "have-maskine", name: "Maskinkrævende arbejde", value: 499, unit: "time", isFrom: true },
      { id: "have-affald", name: "Bortskaffelse af haveaffald", value: 399, unit: "stk", isFrom: true },
    ],
  },
  {
    id: "flyttehjaelp",
    title: "Flyttehjælp",
    note: "Minimum 2 timer. De første 25 km er inkluderet, derefter 12 kr./km. Klaver, flygel, pengeskab og særlige genstande samt erhvervsflytninger: individuelt tilbud. Genstande op til 90 kg: intet særskilt tillæg ved forsvarlig håndtering.",
    items: [
      { id: "flyt-2", name: "2 flyttemænd + varevogn", value: 995, unit: "time" },
      { id: "flyt-3", name: "3 flyttemænd + varevogn", value: 1449, unit: "time" },
      { id: "flyt-90-120", name: "Tungt løft 90–120 kg", value: 499, unit: "genstand" },
      { id: "flyt-120-180", name: "Tungt løft 120–180 kg", value: 799, unit: "genstand" },
      { id: "flyt-180", name: "Tungt løft over 180 kg", quote: true },
    ],
  },
  {
    id: "eventplanlaegning",
    title: "Eventplanlægning",
    items: [
      { id: "plan-koordinering", name: "Royal Koordinering", value: 4995, unit: "stk", isFrom: true },
      { id: "plan-planlaegning", name: "Royal Planlægning", value: 8995, unit: "stk", isFrom: true },
      { id: "plan-full", name: "Royal Full Service", quote: true },
    ],
  },
];

export const UNIT_SUFFIX = {
  time: "/time",
  kuvert: " pr. kuvert",
  "gæst": " pr. gæst",
  genstand: " pr. genstand",
  stk: "",
};
